let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2Ckpu")).then(() => parcelRequire('aWV53'));